import { render, staticRenderFns } from "./toolbar_button.vue?vue&type=template&id=712e2412&scoped=true&lang=pug"
import script from "./toolbar_button.vue?vue&type=script&lang=js"
export * from "./toolbar_button.vue?vue&type=script&lang=js"
import style0 from "./toolbar_button.vue?vue&type=style&index=0&id=712e2412&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712e2412",
  null
  
)

export default component.exports